import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import './ReportFileTransfer.css';
import { injectIntl } from 'react-intl';

export interface IReportFile {
  name: string;
  file?: File;
  status: 'added' | 'inprogress' | 'error' | 'ready' | 'finished';
  progress: number;
  errorMessage?: string;
  delete: () => void;
  type: string;
  response?: any;
  intl: any;
}

const ReportFileTransfer = (props: IReportFile) => {

  const [showError, setShowError] = useState(false);

  const Icon = (props: IReportFile) => {
    switch (props.status) {
      case 'inprogress':
        setShowError(false);
        return <FontAwesomeIcon className="icon spinner" icon="spinner" />
      case 'error':
        return <div onClick={() => setShowError(!showError)}>
                <FontAwesomeIcon
                  className="icon error"
                  icon="exclamation-triangle"
                  color="red"
                  title={props.errorMessage}
                /></div>
      case 'ready':
        setShowError(false);
        return <FontAwesomeIcon className="icon" icon="check" color="green" />
      case 'finished':
        setShowError(false);
        return <FontAwesomeIcon className="icon" icon="check-double" color="green" />
      default:
        setShowError(false);
        return <FontAwesomeIcon className="icon" icon="question-circle" />;
    }
  }

  const getTransferErrors = (response: any) => {
    const rowErrors: JSX.Element[] = [];
    let index: number = 0;
    if (response && response.errors && Array.isArray(response.errors) && response.errors.length > 0) {
      response.errors.forEach((e: any) => rowErrors.push(
        e.id ?
        <div className="rowError" key={++index}>{e.row} {e.str} {props.intl.formatMessage({id: 'filetransfer.error.row.' + e.id})}</div>
        : <></>
      ));
    } else if(typeof(response)==='string' && response !== '') {
      rowErrors.push(<div className="rowError" key={++index}>{response}</div>);
    }
    return rowErrors;
  }

  return (
    <div className="col-md-9 ReportFileTransfer">
      <div className="name-progress">
        <div className="filename">{props.name}</div>
        <div className={`progress ${props.status}`} style={{width: props.progress + '%'}}/>
      </div>
      <Icon {...props}/>
      { props.status !== 'finished' &&
        <div className="delete" onClick={() => props.delete()}><FontAwesomeIcon icon="trash-alt"/></div>
      }
      { showError &&
        <div className="error-modal">
          <div className="modal-close-button" onClick={() => setShowError(false)}>X</div>
            <div className="error-modal-header">{ props.errorMessage }</div>
            { getTransferErrors(props.response) }
        </div>
      }
    </div>
  );
}

export default injectIntl(ReportFileTransfer);
